module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-TRELLO.73a380dc.png";